export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    monthly: 15,
    yearly: 12,
    tagline: "For solo advertisers testing the waters",
    adSpend: "Up to $3,000 ad spend",
    clicks: "5,000 clicks / mo",
    features: [
      "Google Ads protection",
      "Automated IP blocking",
      "Basic fraud reports",
      "1 connected domain",
      "Email support",
    ],
    lookup: { monthly: "starter_monthly", yearly: "starter_yearly" },
    highlight: false,
  },
  {
    id: "growth",
    name: "Growth",
    monthly: 39,
    yearly: 31,
    tagline: "For growing brands scaling paid traffic",
    adSpend: "Up to $15,000 ad spend",
    clicks: "25,000 clicks / mo",
    features: [
      "Google + Meta + Bing",
      "Real-time threat detection",
      "Custom blocking rules",
      "5 connected domains",
      "VPN / Proxy filtering",
      "Priority support",
    ],
    lookup: { monthly: "growth_monthly", yearly: "growth_yearly" },
    highlight: true,
  },
  {
    id: "pro",
    name: "Pro / Scale",
    monthly: 79,
    yearly: 63,
    tagline: "For high-spend performance teams",
    adSpend: "Up to $50,000 ad spend",
    clicks: "100,000 clicks / mo",
    features: [
      "All ad networks",
      "Cross-domain protection",
      "Competitor click prevention",
      "Chargeback reports",
      "Dedicated support",
    ],
    lookup: { monthly: "pro_monthly", yearly: "pro_yearly" },
    highlight: false,
  },
  {
    id: "agency",
    name: "Agency",
    monthly: 149,
    yearly: 119,
    tagline: "For agencies managing many clients",
    adSpend: "$150k+ / Unlimited domains",
    clicks: "Unlimited clicks",
    features: [
      "Whitelabel reporting",
      "Client sub-accounts",
      "Full API access",
      "Unlimited domains",
      "SLA + onboarding",
    ],
    lookup: { monthly: "agency_monthly", yearly: "agency_yearly" },
    highlight: false,
  },
];
